module.exports = __webpack_public_path__ + "img/relaxY-logo-text-blue.fb22ea8b.png";